import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { company } from '~/company/Company';
import CartContent from '~/pages/Cart/CartContent';
import EmptyCart from '~/pages/Cart/EmptyCart';

import { cartStore } from '~/stores';

import MobileHeaderLayout from '../Main/MobileHeader/MobileHeaderLayout';
import MobileHeaderTitle from '../Main/MobileHeader/MobileHeaderTitle';

import styles from './Cart.module.scss';
import { useUserVerificationStatusChecker } from './hooks';

const Cart = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { t } = useTranslation();

  useUserVerificationStatusChecker();

  useEffect(() => {
    cartStore.enableCalculate();
    return () => cartStore.disableCalculate();
  }, []);

  const onBackClick = () => {
    if (state?.from === 'checkout') {
      navigate('/');
      return;
    }

    if (typeof window === 'undefined') {
      return;
    }

    window.history.length === 1 ? navigate('/') : navigate(-1);
  };

  return cartStore.cart.length > 0 ? (
    <div className={styles.contentWr} data-company={company.name}>
      <MobileHeaderLayout
        content={
          <MobileHeaderTitle
            isVisibleBackButton={!company.newDesignSystemEnabled}
            text={t('myCart')}
            onBackClick={onBackClick}
          />
        }
      />
      <div className="content-layout">
        <CartContent />
      </div>
    </div>
  ) : (
    <EmptyCart />
  );
};

export default observer(Cart);
